export enum ActivityType {
  LEARNING = 'Learning',
  ACTIVITY = 'Activity',
  ACHIEVEMENT = 'Achievement',
  OBSERVATIONS = 'Observations',
  FOOD = 'Food',
  POTTY = 'Potty',
  NAP = 'Nap',
  HEALTH = 'Health',
  MEDICATIONS = 'Meds',
  INCIDENT = 'Incident',
  MEETING = 'Meeting',
  NOTES = 'Notes',
  // ATTENDANCE = 'Attendance',
  UNKNOWN = 'Unknown',
}

export const ACTIVITY_TYPES = Object.values(ActivityType)
